import { createEntityAdapter } from '@reduxjs/toolkit';

export const filePermissionsAdapter = createEntityAdapter();
export const assignmentsAdapter = createEntityAdapter();
export const workDemoProjectsAdapter = createEntityAdapter();
export const workDemoEmployersAdapter = createEntityAdapter();
export const workDemoResourcesAdapter = createEntityAdapter();
export const workTimeSaldoItemsAdapter = createEntityAdapter({
  selectId: (workTimeSaldoItem) =>
    `${workTimeSaldoItem.PK}#${workTimeSaldoItem.date}`,
});

export const {
  selectAll: selectAllFilePermissions,
  selectById: selectFilePermissionById,
  selectIds: selectFilePermissionIds,
} = filePermissionsAdapter.getSelectors(
  (state) => state.workCalendar.filePermissions_demo
);

export const {
  selectAll: selectAllAssignments,
  selectEntities: selectAssignmentEntities,
  selectById: selectAssignmentById,
  selectIds: selectAssignmentIds,
} = assignmentsAdapter.getSelectors(
  (state) => state.workCalendar.assignments_demo
);

export const { selectEntities: selectWorkTimeSaldoItemsEntities } =
  workTimeSaldoItemsAdapter.getSelectors(
    (state) => state.workCalendar.workTimeSaldoItems
  );

export const selectWorkTimeSaldoTotalItem = (
  state,
  userId,
  employerBusinessId
) => {
  if (!userId || !employerBusinessId) return undefined;
  const entities = selectWorkTimeSaldoItemsEntities(state);
  const totalKey = `USER#${userId}#BUSINESS_ID#${employerBusinessId}#TOTAL`;
  return entities[totalKey];
};
